export default {
  'Please select an output format': 'Bitte Ausgabeformat auswählen',
}